import { atom } from 'recoil'

import { BayMachine, BayMachineList } from '../utils'
import { BayGridSize } from '../utils/socket/manager'


export type BayGridArray = (BayMachine | undefined)[][]

export const bayGridSizeState = atom<BayGridSize>({
  key: 'bayGridSize',
  default: new BayGridSize(),
})

export const bayMachinesState = atom<BayMachineList>({
  key: 'bayMachinesState',
  default: [],
})

export const bayGridState = atom<BayGridArray>({
  key: 'bayGridState',
  default: [[]],
})
